module.exports = __webpack_public_path__ + "static/media/批量1.7ad07c87.png";